import { render, staticRenderFns } from "./sel_doctor.vue?vue&type=template&id=0b1a8433&scoped=true&"
import script from "./sel_doctor.vue?vue&type=script&lang=js&"
export * from "./sel_doctor.vue?vue&type=script&lang=js&"
import style0 from "./sel_doctor.vue?vue&type=style&index=0&id=0b1a8433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1a8433",
  null
  
)

export default component.exports